import { UTILITY_BILLS_PAGE } from "../consts";

export const UTILITY_BILL_PAGE = {
  ABSOLUTE_PATH: (billId: string) =>
    `${UTILITY_BILLS_PAGE.ABSOLUTE_PATH}/${billId}`,
  PATH: ":billId",
  KEY: "billId",
} as const;
